type Type =
  | "GMW"
  | "GLD"
  | "GMN"
  | "GAR"
  | "FRD"
  | "GUF"
  | "GPD"
  | "SAD"
  | "SLD"
  | "CPT"
  | "BHRGT"
  | "BHRG"
  | "BHRP"
  | "SFR";

const typeToDocsLinkMap: Record<Type, string> = {
  GMW: "https://www.bro-productomgeving.nl/bpo/latest/grondwatermonitoring/grondwatermonitoringput-gmw/gmw-berichtencatalogus-innamewebservice",
  GLD: "https://www.bro-productomgeving.nl/bpo/latest/grondwatermonitoring/grondwaterstandonderzoek-gld/gld-berichtencatalogus-innamewebservice",
  GMN: "https://www.bro-productomgeving.nl/bpo/latest/grondwatermonitoring/grondwatermonitoringnet-gmn/gmn-berichtencatalogus-innamewebservice",
  FRD: "https://www.bro-productomgeving.nl/bpo/latest/grondwatermonitoring/formatieweerstandonderzoek-frd/frd-berichtencatalogus-innamewebservice",
  GAR: "https://www.bro-productomgeving.nl/bpo/latest/grondwatermonitoring/grondwatersamenstellingsonderzoek-gar/gar-berichtencatalogus-innamewebservice",
  GUF: "https://www.bro-productomgeving.nl/bpo/latest/grondwatergebruik/grondwatergebruiksysteem-guf/guf-berichtencatalogus-innamewebservice",
  GPD: "https://www.bro-productomgeving.nl/bpo/latest/grondwatergebruik/grondwaterproductiedossier-gpd/gpd-berichtencatalogus-innamewebservice",
  SAD: "https://www.bro-productomgeving.nl/bpo/latest/grondwatergebruik/samenstellingsonderzoek-activiteitendatabase-sad/sad-berichtencatalogus-innamewebservice",
  SLD: "https://www.bro-productomgeving.nl/bpo/latest/grondwatergebruik/samenstellingsonderzoek-licentiegegevens-sld/sld-berichtencatalogus-innamewebservice",
  CPT: "https://www.bro-productomgeving.nl/bpo/latest/bodem-en-grondonderzoek/geotechnisch-sondeeronderzoek-cpt/cpt-innamehandboek",
  BHRGT:
    "https://www.bro-productomgeving.nl/bpo/latest/bodem-en-grondonderzoek/booronderzoek-bhr/geotechnisch-booronderzoek-bhr-gt/berichtencatalogus-innamewebservice-bhr-gt",
  BHRG: "https://docs.geostandaarden.nl/bro/vv-st-bhr-g-20251002/",
  BHRP: "https://docs.geostandaarden.nl/bro/def-im-bhr-p-20220901/",
  SFR: "https://www.bro-productomgeving.nl/bpo/latest/bodem-en-grondonderzoek/wandonderzoek-sfr/berichtencatalogus-innamewebservice-sfr",
};

export const getDocsLinkMarkdown = (type: Type) => `

[BRO-documentatie](${typeToDocsLinkMap[type]})`;
